import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent {

  public loading:boolean = true;
  public CurrentDetail:any=[];
  public loginDetail:any=[];
  public imgURL: any = "";
  public planList:any=[];
  public cityList:any=[];
  public stateList:any=[];
  public countryList:any=[];
  public colorList:any=[];
  public achivementList:any=[];
  public certificateList:any=[];
  public genderList:any=[];
  public raceList:any=[];
  public abilityList:any=[];
  public expertList:any=[];
  public allmasterData:any={};
  public colorCode:any='#a0d7ff';
  public otherSelection:any='';
  public bankDetail:any=[];
  public expertiseName:any='';

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) { 
    this.getCountry();
    this.CurrentDetail= JSON.parse(localStorage.getItem('gra_EditData')||'{}');
    this.imgURL =this.CurrentDetail.profile_image;
    this.getDEtail();
    this.loading= false;
  }

  ngOnInit(): void {
  }


  getDEtail(){
    var detail={
      id:this.CurrentDetail._id
    }; 
    this.service.PostApis(detail,'/user-detail').subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this;
        if(response.data.record[0].other_user_expertise.length !=0){
          self.expertiseName=response.data.record[0].other_user_expertise[0].content;    
          self.otherSelection=response.data.record[0].other_user_expertise[0].content;
        }
        if(response.data.record[0].expertise.length !=0){
          response.data.record[0].expertise.filter((el:any)=>{
            if(!el.childContent){
            if(self.expertiseName!=''){
              self.expertiseName= self.expertiseName+ ', '+  el.name;
            } else {
              self.expertiseName=el.name;
            }
          }
          })
        } 
        this.expertList=response.data.record[0].expertise;
        if(response.data.record[0].bank_account_added== true){
          response.data.record[0].bankAccounts[0].account_number = 'XXXXXXXX'+response.data.record[0].bankAccounts[0].last4
          this.countryList.filter((el:any)=>{
            if(el.code == response.data.record[0].bankAccounts[0].country){ 
              response.data.record[0].bankAccounts[0].country_name =el.name;
            }
        })
          this.bankDetail =response.data.record[0].bankAccounts[0];
        }
        if(response.data.record[0].gender.length !=0){
          response.data.record[0].gender=response.data.record[0].gender[0].name;
        } else {
          response.data.record[0].gender='--';
        }
        if(response.data.record[0].race.length !=0){
          response.data.record[0].race=response.data.record[0].race[0].name;
        } else {
          response.data.record[0].race='--';
        }
        if(response.data.record[0].ability.length !=0){
          response.data.record[0].ability=response.data.record[0].ability[0].name;
        } else {
          response.data.record[0].ability='--';
        } 
        if(response.data.record[0].primarypillars.length !=0){
          response.data.record[0].primarypillarss=response.data.record[0].primarypillars[0].name;
          response.data.record[0].primarypillarscolor=response.data.record[0].primarypillars[0].color;
        } else {
          response.data.record[0].primarypillarss='--';
          response.data.record[0].primarypillarscolor='#000';
        }
        if(response.data.record[0].achievement !=''){
          var jk:any= response.data.record[0].achievement.split(',');
          jk.filter((el:any)=>{
            self.achivementList.push (el);
          })
        }
       if(response.data.record[0].certifications !=''){
        var jk:any= response.data.record[0].certifications.split(',');
        jk.filter((el:any)=>{
          self.certificateList.push (el);
        })
       }
      //  if(response.data.record[0].certifications ==''){
      //     response.data.record[0].certifications='--';
      //   }
      //   if(response.data.record[0].achievement ==''){
      //     response.data.record[0].achievement='--';
      //   }        
        response.data.record[0].roles= response.data.record[0].roles[0]._id;
        this.CurrentDetail=response.data.record[0];
        this.loading=false;
      } else {
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  getCountry(){
    const url = "/country"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.countryList = response.data;     
      }
    }), (error) => { this.loading =false; });
  }


}
